import { useState, useEffect } from "react";
import Button from "../../Core/Button/Button";
import SelectSearch from "../../Core/Fields/Floating/SelectSearch";
import { getLastFiscalYears } from "../getLastFiscalYears";
import Date from "../../Core/Fields/Floating/Date";
import SelectMultiSearch from "../../Core/Fields/Floating/SelectMultiSearch";

const ChartFilterPopup = ({ show, onClose, filters, setFilters, fields }) => {
  const [localFilters, setLocalFilters] = useState({
    period: "Monthly",
    fiscal_year: "2024-2025",
    from_date: "",
    to_date: "",
    status: []
  });

  const periodOptions = [
    { label: "Monthly", value: "Monthly" },
    { label: "Quarterly", value: "Quarterly" },
    { label: "Half-Yearly", value: "Half-Yearly" },
    { label: "Yearly", value: "Yearly" }
  ];

  const fiscalYearOptions = getLastFiscalYears(10).map(year => ({
    label: year,
    value: year
  }));

  const statusOptions = [
     { label: "Draft", value: "Draft" },
     { label: "On Hold", value: "On Hold" },
     { label: "To Deliver and Bill", value: "To Deliver and Bill" },
     { label: "To Bill", value: "To Bill" },
     { label: "To Deliver", value: "To Deliver" },
     { label: "Completed", value: "Completed" },
     { label: "Cancelled", value: "Cancelled" },
     { label: "Closed", value: "Closed" }
  ];

  const handleStatusChange = (values) => {
    setLocalFilters(prev => ({
      ...prev,
      status: values
    }));
  };

  useEffect(() => {
    if (show && filters) {
      setLocalFilters(prev => ({
        ...prev,
        ...filters
      }));
    }
  }, [show, filters]);

  const handleChange = (field, value) => {
    setLocalFilters(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleApply = () => {
    const filteredValues = {};
    fields.forEach(f => {
      filteredValues[f] = localFilters[f];
    });
    
    setFilters(filteredValues);
    onClose();
  };

  const handleReset = () => {
    const resetObj = {};
    fields.forEach(f => {
      if (f === "status") resetObj[f] = [];
      else resetObj[f] = "";
    });
    setLocalFilters(prev => ({
      ...prev,
      ...resetObj
    }));
  };

  if (!show) return null;

  return (
    <div
      className="modal show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      onClick={onClose}
    >
      <div
        className="modal-dialog modal-dialog-centered modal-md"
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="modal-header py-2">
           <h5 className="modal-title" style={{fontSize:'17.5px'}}>Filter</h5>
            <button 
              type="button" 
              style={{fontSize:'11px'}}
              className="btn-close" 
              onClick={onClose}
            />
          </div>

          <div className="modal-body">
            <div className="row mb-3">
              {fields.includes("period") && (
                <div className="col-md-6 mb-3">
                  <SelectSearch
                    list={periodOptions}
                    label="Period"
                    getOptionLabel={item => item.label}
                    getOptionValue={item => item.value}
                    value={localFilters.period}
                    onChange={value => handleChange("period", value)}
                  />
                </div>
              )}

              {fields.includes("fiscal_year") && (
                <div className="col-md-6 mb-3">
                  <SelectSearch
                    list={fiscalYearOptions}
                    label="Fiscal Year"
                    getOptionLabel={item => item.label}
                    getOptionValue={item => item.value}
                    value={localFilters.fiscal_year}
                    onChange={value => handleChange("fiscal_year", value)}
                  />
                </div>
              )}

               {fields.includes("from_date") && (
                <div className="col-md-6 mb-3">

                  <Date
                    id="fromDate"
                    label="Filter From Date"
                    value={localFilters.from_date}
                    onChange={e => handleChange("from_date", e.target.value)}
                  />

                  
                </div>
              )}

              {fields.includes("to_date") && (
                <div className="col-md-6">
                  <Date
                  id="toDate"
                  label="Filter To Date"
                   value={localFilters.to_date}
                    onChange={e => handleChange("to_date", e.target.value)}
                />
                </div>
              )}

              {fields.includes("status") && (
                <div className="col-12 mt-2">
            
                  <SelectMultiSearch
                                      label="Status"
                                      options={statusOptions}
                                       value={localFilters.status}
                                      onChange={handleStatusChange}
                                    />
                </div>
              )}
            </div>
          </div>

          <div className="modal-footer">
            <Button className="custom-btn-9898970" onClick={handleReset}>
              Reset
            </Button>
            <Button className="custom-btn-00989" onClick={handleApply}>
              Apply
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};


export default ChartFilterPopup